import script from "./UserBadge.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserBadge.vue?vue&type=script&lang=ts&setup=true"

import "./UserBadge.vue?vue&type=style&index=0&id=1ed9192d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ed9192d"]])

export default __exports__